import React, { useReducer } from 'react';
import SettingsContext from './settingsContext';
import settingsReducer from './settingsReducer';

import {
  isFunctionalCookieEnabled,
  isDarkModeCookieEnabled,
  isFormDataCookieEnabled,
} from '../../components/utils/checkCookies';

import { SET_DARK_MODE, REFRESH, SET_FORM_SAVE, SET_SETTINGS } from '../types'; // eslint-disable-next-line*/

import { DOMAIN } from '../../components/links';

import imagesDataJson from '../../../public/images/imgindex.json'; /* here are path to folders and list of filenames */
import imgMetaData from '../../../public/images/metadata.json';

const mergeImagesData = (imagesDataJson, metaData) => {
  const mergedData = {};
  const metaDataOrder = Object.keys(metaData); // get the order of filenames from metaData.json

  // Define the keys to separate the data
  const keys = [
    'Gartenarbeit',
    'Hausmeisterdienste',
    'Landschaftsbau',
    'Reparaturenservice',
    'Umzuege',
  ];
  // https://newhouse-facility.de/images/metadata.json

  keys.forEach((key) => {
    const basePath = `c:\\nhfm\\static\\images\\gallery\\${key}`;
    const thumbsPath = `${basePath}\\thumbs`;

    // Initialize the structure for each key
    mergedData[key] = {
      images: [],
      // thumbs: [],
    };

    // Process images

    if (imagesDataJson[basePath]) {
      // collect all valid images first
      const unsortedImages = [];

      imagesDataJson[basePath].forEach((image) => {
        if (image.fileName && metaData[image.fileName]?.isEnabled) {
          const thumb = imagesDataJson[thumbsPath]?.find(
            (thumb) => thumb.fileName === image.fileName
          );
          unsortedImages.push({
            fileName: image.fileName,
            original: `${DOMAIN}/images/gallery/${key}/${image.fileName}`,
            thumbnail: thumb
              ? `${DOMAIN}/images/gallery/${key}/thumbs/${thumb.fileName}`
              : null,
            description: metaData[image.fileName]?.description || '',
          });
        }
      });

      // Sort images based on their order in metadata.json
      mergedData[key].images = unsortedImages.sort((a, b) => {
        return (
          metaDataOrder.indexOf(a.fileName) - metaDataOrder.indexOf(b.fileName)
        );
      });
    } // end if

    // if (imagesDataJson[basePath]) {
    //   imagesDataJson[basePath].forEach((image) => {
    //     if (image.fileName) {
    //       // Find the corresponding thumbnail
    //       const thumb = imagesDataJson[thumbsPath]?.find(
    //         (thumb) => thumb.fileName === image.fileName
    //       );

    //       // Only process items with a valid fileName and also is isEnabled or not
    //       if (metaData[image.fileName]?.isEnabled) {
    //         mergedData[key].images.push({
    //           fileName: image.fileName,
    //           original: `${DOMAIN}/images/gallery/${key}/${image.fileName}`,
    //           thumbnail: thumb
    //             ? `${DOMAIN}/images/gallery/${key}/thumbs/${thumb.fileName}`
    //             : null,
    //           description: metaData[image.fileName]?.description || '',
    //         });
    //       }
    //     }
    //   });
    // }
  });

  return mergedData;
};

// const imagesMetadataOnServer = async () => {
//   return await fetch('https://newhouse-facility.de/images/metadata.json').catch(
//     (err) => {
//       if (err) return null;
//     }
//   );
// };

// init state
const SettingsState = (props) => {
  let localSett = { darkMode: false, formSave: false }; // this is default setting

  if (isFunctionalCookieEnabled()) {
    // check if there are settings saved in a cookie, if not, use default above
    if (isDarkModeCookieEnabled()) {
      localSett = { ...localSett, darkMode: true };
    }
    if (isFormDataCookieEnabled()) {
      localSett = { ...localSett, formSave: true };
    }
  }
  // console.log('imagesMetadataOnServer', await imagesMetadataOnServer);
  const initialState = {
    darkMode: localSett.darkMode,
    formSave: localSett.formSave,
    imagesGallery: mergeImagesData(imagesDataJson, imgMetaData),
  };

  const [state, dispatch] = useReducer(settingsReducer, initialState);

  const setDarkMode = (booleanVal) => {
    dispatch({ type: SET_DARK_MODE, payload: booleanVal });
  };

  const setFormSave = (booleanVal) => {
    dispatch({ type: SET_FORM_SAVE, payload: booleanVal });
  };

  const setSettings = (obj) => {
    dispatch({ type: SET_SETTINGS, payload: obj });
  };

  const resetSettings = () => {
    dispatch({ type: REFRESH });
  };

  return (
    <SettingsContext.Provider
      value={{
        darkMode: state.darkMode,
        formSave: state.formSave,
        imagesGallery: state.imagesGallery,
        setDarkMode,
        setFormSave,
        setSettings,
        resetSettings,
      }}
    >
      {props.children}
    </SettingsContext.Provider>
  );
};

export default SettingsState;
